export const ONEWORLD_LOGO_SRC = `${import.meta.env.BASE_URL}images/oneworld-logo.webp`;
